import type { TextureManager } from '../texture-manager.class';

/**
 * Dispose of all resources
 */
export const disposeCfn = (self: TextureManager, _params: Record<string, never>): void => {
	const textures = self.textures;
	const normalMaps = self.normalMaps;
	const alphaMaps = self.alphaMaps;
	const displacementMaps = self.displacementMaps;
	const materials = self.materials;

	// Dispose textures
	for (const texture of textures.values()) {
		texture.dispose();
	}
	textures.clear();

	// Dispose normal maps
	for (const texture of normalMaps.values()) {
		texture.dispose();
	}
	normalMaps.clear();

	// Dispose alpha maps
	for (const texture of alphaMaps.values()) {
		texture.dispose();
	}
	alphaMaps.clear();

	// Dispose displacement maps
	for (const texture of displacementMaps.values()) {
		texture.dispose();
	}
	displacementMaps.clear();

	// Dispose materials
	for (const material of materials.values()) {
		material.dispose();
	}
	materials.clear();

	// Dispose environment map
	const environmentMap = self.environmentMap;
	if (environmentMap) {
		environmentMap.dispose();
		self.environmentMap = null;
	}

	// Dispose PMREM preloader
	const pmremPreloader = self.pmremPreloader;
	if (pmremPreloader) {
		pmremPreloader.dispose();
	}

	// Dispose KTX2 support
	const ktx2Support = self.ktx2Support;
	if (ktx2Support) {
		ktx2Support.dispose();
	}
};
